import {
    FETCH_PARC_BEGIN,
    FETCH_PARC_SUCCESS,
    FETCH_PARC_ERROR,
    FETCH_PARC_RESET,
    FETCH_PARCCOLOR_BEGIN,
    FETCH_PARCCOLOR_ERROR,
    FETCH_PARCCOLOR_RESET,
    FETCH_PARCCOLOR_SUCCESS,
    FETCH_PARCRESUME_BEGIN,
    FETCH_PARCRESUME_SUCCESS,
    FETCH_PARCRESUME_ERROR
} from '../actions/parcActions'

const initialState = {
    vehicules: [],
    redVehicules: [],
    resume: {},
    fetchParc: {
        loading: false,
        error: false
    },
    fetchRedParc: {
        loading: false,
        error: false
    },
    fetchResume: {
        loading: false,
        error: false
    }
}

export default function parcReducer(state = initialState, action) {
    let nextState
    switch (action.type) {
        case FETCH_PARC_BEGIN:
            return {
                ...state,
                fetchParc: {
                    loading: true,
                    error: false
                }
            }

        case FETCH_PARC_SUCCESS:
            nextState = {
                ...state,
                vehicules: action.payload.vehicules,
                fetchParc: {
                    loading: false,
                    error: false
                }
            }
            return nextState

        case FETCH_PARC_ERROR:
            return {
                ...state,
                fetchParc: {
                    loading: false,
                    error: action.payload.error
                }
            }
        case FETCH_PARC_RESET:
            return {
                ...state,
                fetchParc: {
                    loading: false,
                    error: false
                }
            }
        case FETCH_PARCCOLOR_BEGIN:
            return {
                ...state,
                fetchRedParc: {
                    loading: true,
                    error: false
                }
            }

        case FETCH_PARCCOLOR_SUCCESS:
            nextState = {
                ...state,
                redVehicules: action.payload.redVehicules,
                fetchRedParc: {
                    loading: false,
                    error: false
                }
            }
            return nextState

        case FETCH_PARCCOLOR_ERROR:
            return {
                ...state,
                fetchRedParc: {
                    loading: false,
                    error: action.payload.error
                }
            }
        case FETCH_PARCCOLOR_RESET:
            return {
                ...state,
                fetchRedParc: {
                    loading: false,
                    error: false
                }
            }
        case FETCH_PARCRESUME_BEGIN:
            return {
                ...state,
                fetchResume: { loading: true, error: false }
            }
        case FETCH_PARCRESUME_SUCCESS:
            return {
                ...state,
                resume: action.payload.resume,
                fetchResume: { loading: false, error: false }
            }
        case FETCH_PARCRESUME_ERROR:
            return {
                ...state,
                fetchResume: { loading: false, error: action.payload.error }
            }
        default:
            return state
    }
}